import { ReserveAccountModel } from 'Pages/orders_design'
import { serialize } from 'object-to-formdata'
import { axiosDS } from '@pp/axios'
import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'

async function checkReserveAccountPossibility(inn: number, product_ids: number[]) {
	const res = await axiosDS().post<boolean>(urls.orders.possibility_to_reserve_an_account, {
		data: {
			inn,
			product_ids,
		},
	})
	return res.data
}

async function createReserveAccount(id: number, data: ReserveAccountModel) {
	const formData = serialize({ data })
	const res = await axiosDS().post<ReserveAccountModel>(
		urls.orders.create_reserve_account.replace(':id', id.toString()),
		formData
	)
	return res.data
}

async function sendOrderWithoutReserveAccount(id: number) {
	const res = await axiosDS().post<SimpleResponse>(
		urls.orders.force_send.replace(':id', id.toString())
	)
	return res.data
}

async function getReserveAccountInOrder(data: { id: number }) {
	const res = await axiosDS().get<ReserveAccountModel>(
		urls.orders.show_reserve_account.replace(':id', data.id.toString())
	)
	return res.data
}

export const reserveAccountApi = {
	checkReserveAccountPossibility,
	createReserveAccount,
	sendOrderWithoutReserveAccount,
	getReserveAccountInOrder,
}
